'use strict';
var twentyninetimes = twentyninetimes || {};

twentyninetimes.uspAccordion = twentyninetimes.uspAccordion || function () {

	function init() {
		const accordions = document.querySelectorAll('.js-usp-accordion');
		if ( accordions ) {
            for (let i = 0; i < accordions.length; i++) {
                const currentAccordion = accordions[i];
                const firstAccordionItem = currentAccordion.querySelectorAll('.js-accordion')[0];
                // const firstToggle = firstAccordionItem.querySelector('.js-accordion-toggle');
                // const firstContent = firstAccordionItem.querySelector('.js-accordion-content');
                // firstAccordionItem.classList.add('active');
                // firstToggle.setAttribute('aria-expanded', 'true');
                // firstContent.style.height = 'auto';
            }
		}
	}

	return {
		init : init
	};

}();